import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import app from "./base.js";
import { AuthContext } from "./Auth.js";
import {Component} from "react";
import backBanner from "./backBanner.jpg"
import logoParkvillegreens from "./logoParkvillegreens.png"

const project_code = "parkville_greens_erin_gates";
var userEmail;
var userPhoneNumber;
var userName;

class LoginPage extends Component{


  componentDidMount(){
    console.log("SIGNUP PAGE COMPONENT DID MOUNT");

    const autoFillEmail = () => {
      var currentHref = window.location.href;
      var splitter = currentHref.split("?");
  
      if(splitter.length > 1 ){
  
        var splitIt = splitter[1].split("=");
        var splitAgain = splitIt[1].split("_split_");
        console.log("split again " + splitAgain);
        if(splitAgain[1] !== "ADMIN"){
          var userAppRef = app.database().ref('/client_appointments/' + project_code + "/" + splitAgain[0] + "/users").child(splitAgain[1]);
    
          userAppRef.once('value', snapshot => {
    
            console.log(snapshot);
            userEmail = snapshot.val().email;
            userName = snapshot.val().fullName;
            userPhoneNumber = snapshot.val().userPhoneNumber;
    
            try{
            var nameElement = document.getElementById("fullName");
            nameElement.innerHTML = userName;
            var nameTextTitle = document.getElementById("nameTextTitle");
            nameTextTitle.innerHTML = "Your Name"
            //console.log(userEmail);
            var emailElement = document.getElementById("userEmail");
            emailElement.value = userEmail;
            }
            catch (error) {
              alert(error);
            }
    
          });
        }
      }
  
  
    }
  
    autoFillEmail();
  }

}



const Login = ({ history }) => {
  const handleLogin = useCallback(
    async event => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);

          var currentHref = window.location.href;
          var splitter = currentHref.split("?");
          var toRedirect = "/";
          if(splitter.length > 1){
            toRedirect = toRedirect + "?" + splitter[1];
          }
        history.push(toRedirect);
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    var currentHref = window.location.href;
    var splitter = currentHref.split("?");
    var toRedirect = "/";
    if(splitter.length > 1){
      toRedirect = toRedirect + "?" + splitter[1];
    }
    return <Redirect to={toRedirect} />;
  }

  const goToSignUp = () =>{
    var currentHref = window.location.href;
    var splitter = currentHref.split("?");
    var toRedirect = "/";
    if(splitter.length > 1){
      toRedirect = toRedirect + "signup?" + splitter[1];
    }

    var startRef = currentHref.split("/login");
    var newRef = startRef[0] + toRedirect;

    console.log("going to "+newRef);
    window.location = newRef;
  }

  const passwordReset = () =>{

    var useEmail = document.getElementById("userEmail");
    var useEmailVal = useEmail.value;
    app.auth().sendPasswordResetEmail(useEmailVal).then(function() {
      // Email sent.
      var forgotEle = document.getElementById("forgotPassword");
      forgotEle.innerHTML = "Email Sent. Send Another? Forgot Password";
    }).catch(function(error) {
      // An error happened.
      console.log(error);
      if(error.code == "auth/invalid-email"){
        console.log("invalid auth email");
        var forgotEle = document.getElementById("forgotPassword");
        forgotEle.innerHTML = "Don't see that email, try again? Forgot Password";
      }
    });

  }

  var loginPage = new LoginPage();

  loginPage.componentDidMount();

  return (
    <>
      <div>
        <img className="BackBanner" src={backBanner} alt="Banner" />;
        <img className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
      </div>
      <div className="BlackFrontOverlay">
        <h2 className="blackBoxTitle">Log in</h2>
        <p className="GreenTitle" id="nameTextTitle"></p>
        <p className="paragraphReg" id="fullName">{userName}</p>
        <form onSubmit={handleLogin}>
          <label className="GreenTitleLabel">
            Email
            <br></br>
            <input id="userEmail" name="email" type="email" placeholder="Email" />
          </label>
          <label className="GreenTitleLabel">
            Password
            <br></br>
            <input name="password" type="password" placeholder="Password" />
          </label>
          <button id="forgotPassword" type="button" className="signOutButton" onClick={()=>{passwordReset();}}>Forgot password?</button>
          <br></br> 
          <button type="button" className="signOutButton" onClick={()=>{goToSignUp();}}>Not signed up? Create Account</button>    
          <button className="joinMeetingButton" type="submit">Log in</button>
        </form>        
      </div>
      
    </>
  );
};

export default withRouter(Login);
